import { Box, Grid, Link, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { Link as RouterLink } from "react-router-dom";
import { Subscription } from "schemas/dashboard";
import { routes } from "schemas/routes";

import { getFollowUpAssistantDate } from "./helper";
import styles from "./styles";

export default function FollowUpAssistantItem({
  isCurrentPlan,
  subscription,
}: {
  isCurrentPlan: boolean;
  subscription: Subscription | null;
}) {
  function generateAssistantText() {
    const daysAway = getFollowUpAssistantDate(subscription);
    if (daysAway === undefined) {
      return "";
    } else if (daysAway === "today") {
      return <>Your next round of automated brand check-ins is running today</>;
    } else {
      return (
        <>
          You're{" "}
          <Box component="span" sx={{ color: blue[600] }}>
            <strong>
              {daysAway} day{daysAway !== 1 ? "s" : ""} away
            </strong>
          </Box>{" "}
          from your next round of automated brand check-ins
        </>
      );
    }
  }

  return (
    <>
      {isCurrentPlan ? (
        <Grid container alignItems="center" sx={{ mb: 1.5 }}>
          <Grid
            container
            justifyContent="left"
            alignItems="center"
            item
            xs="auto"
          >
            <Box sx={styles.iconBlock}>📊</Box>
          </Grid>
          <Grid item xs md>
            <Typography component="div">
              <strong>
                🗓️ Your next Follow-Up Assistant run is coming up!
              </strong>{" "}
              {generateAssistantText()} - we'll surface all the brands you
              should reconnect with in your{" "}
              <strong>
                <Link component={RouterLink} to={`/${routes.inboxCheckins}`}>
                  Inbox &gt; Check-ins
                </Link>
              </strong>{" "}
              page.
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container alignItems="center" sx={{ mb: 1.5 }}>
          <Grid
            container
            justifyContent="left"
            alignItems="center"
            item
            xs="auto"
          >
            <Box sx={styles.iconBlock}>📊</Box>
          </Grid>
          <Grid item xs md>
            <Typography component="div">
              <strong>Follow Up Assistant:</strong> Monthly automated reminders
              to help you reconnect with brands and close repeat deals.
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}
